<template>
    <div class="kfc_menu_wrap">
        <div v-if="disttype == 'zizhu'" class="diner_info_wrap fc" @click="switchDiner">
            <div class="diner_info fr ac">
                <img class="location_icon" src="../../../static/imgs/kfc/location_kfc.png" alt />
                <div class="info_box fc">
                    <h3 v-if="selectedDiner.name">{{selectedDiner.name}} - {{selectedDiner.cityname}}</h3>
                    <p v-if="selectedDiner.address">{{selectedDiner.address}}</p>
                </div>
                <img class="down_icon" src="../../../static/imgs/kfc/down-kfc.png" alt />
            </div>
            <img src="../../../static/imgs/kfc/line.png" alt class="line" />
        </div>
        <!-- <div class="menu_bar" :style="disttype == 'zizhu' ? 'top: 200px; height: calc(100% - 320px);' : 'top: 0; height: calc(100% - 120px);'"> -->
        <div
            class="menu_bar"
            :style="disttype == 'zizhu' ? 'top: 2.666rem; height: calc(100% - 4.266rem);' : 'top: 0; height: calc(100% - 1.6rem);'"
        >
            <div
                v-for="(item, index) in categoryList"
                :key="index"
                class="menu_item_box"
                @click="selectCategory(index)"
                :id="'category' + index"
            >
                <div
                    :class="selectedCategoryIdx == index ? 'menu_item fc ac selected' : 'menu_item fc ac'"
                >
                    <img :src="imgBaseUrl + item.logo" alt />
                    <span>{{item.name}}</span>
                </div>
            </div>
        </div>
        <div
            class="product_list"
            id="product_list"
            ref="scroll_box"
            :style="disttype == 'zizhu' ? 'top: 2.666rem; height: calc(100% - 4.266rem);' : 'top: 0; height: calc(100% - 1.6rem);'"
        >
            <div
                v-for="(item, index) in productList"
                :key="index"
                class="category_item fc"
                :id="'view'+index"
            >
                <h3>{{item[0]}}</h3>
                <div
                    class="product_item fr ac"
                    v-for="(pItem, pIndex) in item[1]"
                    :key="pIndex"
                    @click="viewItem(pItem)"
                >
                    <img class="product_img" :src="imgBaseUrl + pItem.logo" alt />
                    <div class="product_info fc afe jsb">
                        <h4 class="product_title">{{pItem.name}}</h4>
                        <span class="price">￥{{pItem.priceDesc ? pItem.priceDesc : pItem.price}}</span>
                        <!-- <div class="frr ac">
                            <span
                                v-show="pItem.martetprice"
                                class="market_price"
                            >￥{{pItem.martetprice}}</span>
                            <span
                                v-show="pItem.martetprice && pItem.price"
                                class="saved"
                            >已省{{(pItem.martetprice - pItem.price).toFixed(1)}}元</span>
                        </div> -->
                        <div v-if="pItem.qty && pItem.qty > 0 && !pItem.choice" class="fr ac">
                            <img
                                @click.stop="removeItem(index, pIndex, pItem)"
                                src="../../../static/imgs/kfc/minus.png"
                                alt
                                class="add_icon"
                            />
                            <span class="item_num">{{pItem.qty}}</span>
                            <img
                                @click.stop="addItem(index, pIndex, pItem)"
                                src="../../../static/imgs/kfc/plus.png"
                                alt
                                class="add_icon"
                            />
                        </div>
                        <img
                            v-else
                            @click.stop="addItem(index, pIndex, pItem)"
                            src="../../../static/imgs/kfc/plus.png"
                            alt
                            class="add_icon"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="footer fr ac jsb">
            <div class="fr ac" @click="openLayer">
                <div class="icon_wrap">
                    <img class="cart_icon" src="../../../static/imgs/kfc/kfc-cart.png" alt />
                    <span v-show="cartQty">{{cartQty}}</span>
                </div>
                <span v-show="cartTotal > 0" class="total">￥{{cartTotal}}</span>
            </div>
            <button class="confirm" @click="confirm">选好了</button>
        </div>
        <transition name="cart_layer">
            <div v-show="showLayer" class="cart_layer fc">
                <div v-for="(item, index) in cartArr" :key="index" class="cart_item_wrap fc">
                    <div class="cart_item fr ac jsb">
                        <div class="fr ac">
                            <span class="item_name">{{item.name}}</span>
                            <span @click="toggleDetail(index)" class="toggle">{{item.isExtend ? "收起" : "详情"}}</span>
                        </div>
                        <div class="fr ac">
                            <span class="item_price">￥{{item.actualPrice}}</span>
                            <div class="num_box fr ac">
                                <img
                                    @click="reduceQty(index)"
                                    src="../../../static/imgs/kfc/minus.png"
                                    alt
                                />
                                <span>{{item.qty}}</span>
                                <img
                                    v-if="!item.choice"
                                    @click="increaseQty(index)"
                                    src="../../../static/imgs/kfc/plus.png"
                                    alt
                                />
                                <img v-else src="../../../static/imgs/kfc/plus-grey.png" alt />
                            </div>
                        </div>
                    </div>
                    <p class="item_desp" v-show="!item.choice && item.description && item.isExtend">{{item.description}}</p>
                    <p class="item_desp" v-show="item.choice && item.comboDesp && item.isExtend">
                        <span>{{item.comboDesp}}</span>
                        <span class="option">{{item.comboSelected}}</span>
                    </p>
                </div>
            </div>
        </transition>
        <div v-show="showLayer" class="shade" @click="showLayer = !showLayer"></div>
    </div>
</template>

<script>
import { Toast } from "mint-ui";
export default {
    data() {
        return {
            disttype: this.$route.query.disttype,
            selectedDiner: this.getLocal("selectedDiner")
                ? this.getLocal("selectedDiner")
                : {},
            imgBaseUrl: this.$global.imgBaseUrl,
            categoryList: [],
            productList: [],
            selectedCategoryIdx: 0,
            cartArr: [],
            cartTotal: 0,
            cartQty: 0,
            showLayer: false,
            scroll: 0,
            heightArr: []
        };
    },
    watch: {
        disttype(val, oldVal) {
            this.getproductList();
            this.showLayer = false;
            let cartArr = [];
            this.cartArr = cartArr;
            this.setLocal("cartArr", cartArr);
            this.calcCartTotal();
        },
        cartArr(val, oldVal) {
            if (!val.length) {
                this.getproductList();
            }
        },
        // selectedCategoryIdx(val, oldVal){
        //      this.$nextTick(() => {
        //         setTimeout(() => {
        //             let elementId = "category" + val;
        //             document.getElementById(elementId).scrollIntoView({ behavior: "smooth" });
        //         }, 5000);
        //     });

        // }
    },
    components: {},
    updated() {
        let productListEle = document.getElementById("product_list");
        if (productListEle) {
            productListEle.addEventListener(
                "scroll",
                this.handleScrollList,
                true
            );
        }
    },
    activated() {
        this.selectedDiner = this.getLocal("selectedDiner")
            ? this.getLocal("selectedDiner")
            : {};
        this.disttype = this.$route.query.disttype;
        let cartArr = this.getLocal("cartArr") ? this.getLocal("cartArr") : [];
        let productList = this.productList;
        if (cartArr.length) {
            for (let i of cartArr) {
                for (let j of productList) {
                    for (let k of j[1]) {
                        if (i.id == k.id) {
                            k.qty = i.qty;
                        }
                    }
                }
            }
        }
        this.cartArr = cartArr;
        this.productList = productList;
        this.calcCartTotal();
    },
    created() {
        this.getproductList();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            const scroll_box = vm.$refs.scroll_box;
            // 记录滚动高度
            scroll_box.scrollTop = vm.scroll;
        });
    },
    beforeRouteLeave(to, from, next) {
        const scroll_box = this.$refs.scroll_box;
        this.scroll = scroll_box.scrollTop;
        next();
    },
    methods: {
        handleScrollList() {
            let listEle = document.getElementById("product_list");
            let scrollTop = listEle.scrollTop;
            this.calcActiveIdx(scrollTop);
        },
        calcActiveIdx(num) {
            let heightArr = this.heightArr;
            for (let idx in heightArr) {
                if (num < heightArr[idx]) {
                    this.selectedCategoryIdx = idx;
                    break;
                }
            }
        },
        getproductList() {
            this.$post({
                method: "kfc.product.list",
                disttype: this.disttype
            }).then(res => {
                if (res.success) {
                    let keyArr = Object.keys(res.data.productList),
                        categoryList = [];
                    for (let i of keyArr) {
                        let idx = i.indexOf("@"),
                            categoryObj = {};
                        categoryObj.name = i.slice(0, idx);
                        categoryObj.logo = i.slice(idx + 1);
                        categoryList.push(categoryObj);
                    }
                    let productList = Object.entries(res.data.productList);
                    for (let i of productList) {
                        let idx = i[0].indexOf("@");
                        i[0] = i[0].slice(0, idx);
                    }
                    this.categoryList = categoryList;
                    this.productList = productList;
                    console.log(productList);
                    let widthUnit = document.documentElement.clientWidth / 750
                    let height = 0,
                        heightArr = [];
                    for (let i of this.productList) {
                        height += parseInt(i[1].length * 220 * widthUnit + 69 * widthUnit);
                        heightArr.push(height);
                    }
                    this.heightArr = heightArr;
                    console.log(heightArr);
                }
            });
        },
        switchDiner() {
            this.$router.go(-1);
        },
        openLayer() {
            if (this.cartQty) {
                this.showLayer = true;
            }
        },
        viewItem(item) {
            let itemTxt = encodeURIComponent(JSON.stringify(item));
            if (item.choice) {
                this.$router.push({
                    path: "/kfcCombo",
                    query: { info: itemTxt }
                });
            } else {
                this.$router.push({
                    path: "/kfcProductDetail",
                    query: {
                        info: itemTxt,
                        cartQty: this.cartQty,
                        cartTotal: this.cartTotal
                    }
                });
            }
        },
        selectCategory(idx) {
            this.selectedCategoryIdx = idx;
            let viewId = "view" + idx;
            document
                .getElementById(viewId)
                .scrollIntoView({ behavior: "smooth" });
        },
        addItem(idx, pidx, item) {
            this.$set(
                this.productList[idx][1][pidx],
                "qty",
                this.productList[idx][1][pidx].qty
                    ? this.productList[idx][1][pidx].qty + 1
                    : 1
            );
            if (item.choice) {
                let itemTxt = encodeURIComponent(JSON.stringify(item));
                this.$router.push({
                    path: "/kfcCombo",
                    query: { info: itemTxt }
                });
            } else {
                let cartArr = this.cartArr;
                if (cartArr.length) {
                    let idArr = [];
                    for (let i of cartArr) {
                        idArr.push(i.id);
                    }
                    if (idArr.indexOf(item.id) < 0) {
                        item.qty = 1;
                        item.isExtend = false
                        cartArr.push(item);
                    } else {
                        let idIdx = idArr.indexOf(item.id);
                        // cartArr[idx].qty = cartArr[idx].qty;
                        cartArr[idIdx].qty = this.productList[idx][1][pidx].qty;
                    }
                } else {
                    item.qty = 1;
                    item.isExtend = false
                    cartArr.push(item);
                }
                this.cartArr = cartArr;
                // this.setLocal("cartArr", cartArr);
                this.calcCartTotal();
                Toast({
                    message: "加入成功",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
            }
            console.log("cartArr", this.cartArr)
        },
        removeItem(idx, pidx) {
            this.$set(
                this.productList[idx][1][pidx],
                "qty",
                this.productList[idx][1][pidx].qty - 1
            );
            let cartArr = this.cartArr;
            for (let i in cartArr) {
                if (cartArr[i].id == this.productList[idx][1][pidx].id) {
                    // if (cartArr[i].qty > 1) {
                    if (this.productList[idx][1][pidx].qty >= 1) {
                        // cartArr[i].qty = cartArr[i].qty;
                        cartArr[i].qty = this.productList[idx][1][pidx].qty;
                    } else {
                        cartArr.splice(i, 1);
                    }
                }
            }
            this.cartArr = cartArr;
            // this.setLocal("cartArr", cartArr);
            this.calcCartTotal();
        },
        // 计算购物车内商品总价
        calcCartTotal() {
            let cartArr = this.cartArr,
                cartTotal = 0,
                cartQty = 0;
            for (let i of cartArr) {
                cartQty += i.qty;
                let actualPrice = 0;
                if (i.choice && i.actualPrice) {
                    cartTotal += i.actualPrice;
                } else if (i.choice) {
                    actualPrice += i.price;
                    for (let j of i.mutiArr[1]) {
                        if (j.isSelected) {
                            actualPrice += j.addprice;
                        }
                    }
                    i.actualPrice = actualPrice;
                    cartTotal += actualPrice;
                } else {
                    i.actualPrice = i.price;
                    cartTotal += i.price * i.qty;
                }
            }
            this.cartTotal = cartTotal.toFixed(1);
            this.cartQty = cartQty;
            this.cartArr = cartArr;
            this.setLocal("cartArr", cartArr);
        },
        increaseQty(idx) {
            let productList = this.productList;
            let cartArr = this.cartArr;
            for (let i of productList) {
                for (let j of i[1]) {
                    if (j.id == cartArr[idx].id) {
                        j.qty = j.qty + 1;
                        cartArr[idx].qty = j.qty;
                        break;
                    }
                }
            }
            this.productList = productList;
            this.cartArr = cartArr;
            this.setLocal("cartArr", cartArr);
            this.calcCartTotal();
        },
        reduceQty(idx) {
            let productList = this.productList;
            let cartArr = this.cartArr;
            for (let i of productList) {
                for (let j of i[1]) {
                    if (cartArr[idx] && j.id == cartArr[idx].id) {
                        j.qty = j.qty - 1;
                        if (j.qty >= 1 && !cartArr[idx].choice) {
                            cartArr[idx].qty = j.qty;
                        } else {
                            cartArr.splice(idx, 1);
                        }

                        break;
                    }
                }
            }

            this.productList = productList;
            this.cartArr = cartArr;
            this.setLocal("cartArr", cartArr);
            this.calcCartTotal();
            if (!cartArr.length) {
                this.showLayer = false;
            }
        },
        confirm() {
            if (!this.cartQty) {
                Toast({
                    message: "请先选择商品",
                    position: "middle",
                    duration: 2000,
                    className: "toastBox"
                });
                return;
            }
            this.$router.push({
                path: "/kfcCheckout",
                query: {
                    cartTotal: this.cartTotal,
                    cartQty: this.cartQty,
                    disttype: this.$route.query.disttype
                }
            });
        },
        toggleDetail(idx){
            this.cartArr[idx].isExtend = this.cartArr[idx].isExtend ? false : true
            this.$forceUpdate()
            console.log("isExtend:", this.cartArr[idx].isExtend)
        },
    }
};
</script>
<style lang="scss">
.kfc_menu_wrap {
    .diner_info_wrap {
        width: 100%;
        height: 200px;
        background: #fff;
        position: fixed;
        top: 0;
        .diner_info {
            width: 100%;
            padding: 0 35px;
            box-sizing: border-box;
            height: 190px;
            .location_icon {
                width: 65px;
                height: 65px;
                margin-right: 20px;
            }
            .info_box {
                width: calc(100% - 130px);
                h3 {
                    font-size: 32px;
                    margin-bottom: 15px;
                }
                p {
                    font-size: 28px;
                    color: #999;
                }
            }
            .down_icon {
                width: 30px;
                height: 30px;
                margin-right: 15px;
            }
        }
        .line {
            width: 100%;
            height: 10px;
        }
    }
    .menu_bar {
        width: 139px;
        font-size: 28px;
        background: #f4f4f4;
        position: fixed;
        left: 0;
        // top: 200px;
        overflow-y: scroll;
        border-right: 1px solid #dedede;
        // height: calc(100% - 320px);
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        .menu_item_box {
            width: 100%;
            .menu_item {
                padding: 20px 0;
                img {
                    width: 50px;
                    height: 50px;
                    margin-bottom: 10px;
                }
                span {
                    width: 100%;
                    padding: 0 5px;
                    box-sizing: border-box;
                    font-size: 22px;
                    text-align: center;
                    line-height: 32px;
                }
            }
            .selected {
                background: #fff;
                color: #d62f35;
            }
        }
    }
    .product_list {
        width: calc(100% - 140px);
        position: fixed;
        // top: 200px;
        left: 140px;
        overflow-y: scroll;
        // height: calc(100% - 320px);
        -webkit-overflow-scrolling: touch;
        .category_item {
            width: 100%;
            h3 {
                width: 100%;
                height: 70px;
                line-height: 70px;
                text-align: center;
                font-size: 32px;
                background: #fff;
                color: #d62f35;
                border-bottom: 1px solid #dededf;
            }
            .product_item {
                width: 100%;
                padding: 20px;
                box-sizing: border-box;
                height: 220px;
                background: #fff;
                border-bottom: 1px solid #dededf;
                .product_img {
                    width: 240px;
                    height: 180px;
                    margin-right: 20px;
                }
                .product_info {
                    width: calc(100% - 260px);
                    height: 180px;
                    .product_title {
                        font-size: 24px;
                        text-align: right;
                        font-weight: bold;
                        line-height: 32px;
                    }
                    .price {
                        font-size: 28px;
                        color: #d62f35;
                        font-weight: bold;
                    }
                    .saved {
                        color: #fc9030;
                        font-size: 20px;
                        margin-right: 18px;
                    }
                    .market_price {
                        font-size: 20px;
                        color: #999;
                        text-decoration: line-through;
                    }
                    .add_icon {
                        width: 45px;
                        height: 45px;
                    }
                    .item_num {
                        width: 50px;
                        text-align: center;
                    }
                }
            }
        }
    }
    .footer {
        width: 100%;
        position: fixed;
        bottom: 0;
        background: #fff;
        z-index: 8;
        height: 120px;
        .icon_wrap {
            width: 80px;
            height: 80px;
            margin-left: 40px;
            position: relative;
            .cart_icon {
                width: 80px;
                height: 80px;
            }
            span {
                background: #d62f35;
                color: #fff;
                position: absolute;
                font-size: 22px;
                top: -5px;
                right: -8px;
                height: 32px;
                line-height: 32px;
                min-width: 22px;
                border-radius: 16px;
                text-align: center;
                padding: 0 10px;
            }
        }
        .total {
            color: #d62f35;
            margin-left: 30px;
            font-size: 32px;
        }
        .confirm {
            width: 250px;
            text-align: center;
            background: #d62f35;
            font-size: 32px;
            color: #fff;
            border-radius: 0;
            height: 120px;
            line-height: 100px;
            padding: 0 40px;
            border-left: 1px solid #fff;
        }
    }
    .cart_layer {
        width: 100%;
        position: fixed;
        bottom: 0;
        z-index: 5;
        padding-bottom: 120px;
        background: #fff;
        .cart_item_wrap {
            border-bottom: 1px solid #dededf;
            .cart_item {
                width: 100%;
                padding: 0 30px;
                box-sizing: border-box;
                height: 80px;
                font-size: 28px;
                .item_name {
                    max-width: 360px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .toggle {
                    font-size: 24px;
                    text-decoration: underline;
                    color: #999;
                    margin-left: 10px;
                }
                .item_price {
                    color: #d62f35;
                }
                .num_box {
                    margin-left: 25px;
                    img {
                        width: 45px;
                        height: 45px;
                    }
                    span {
                        width: 50px;
                        text-align: center;
                    }
                }
            }
            .item_desp {
                background: #fff;
                width: 100%;
                padding: 0 30px 10px 30px;
                box-sizing: border-box;
                font-size: 22px;
                color: #999;
                line-height: 30px;
                .option {
                    color: #d62f35;
                }
            }
        }
    }
    .cart_layer-enter {
        transform: translateY(960px);
    }
    .cart_layer-enter-active {
        transition: all 0.5s;
    }
    .shade {
        width: 100%;
        height: 100%;
        position: fixed;
        bottom: 0;
        z-index: 4;
        background: rgba(0, 0, 0, 0.5);
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/kfc/kfcMenu.vue